import { render } from "./PopupEditor.vue?vue&type=template&id=416be22e&scoped=true"
import script from "./PopupEditor.vue?vue&type=script&lang=js"
export * from "./PopupEditor.vue?vue&type=script&lang=js"

import "./PopupEditor.vue?vue&type=style&index=0&id=416be22e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-416be22e"]])

export default __exports__